
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { reverse, forEach, map, join, filter } from 'lodash';
import MobileLineItem from './MobileLineItem';
import { products } from '../../services';
import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';
import Loading from '../Loding/Loading';
import { NoService } from '.'

class FixedLine extends Component {

  virtualNumberNaming(type) {
    const { translate } = this.props;
    let label = type ? 'virtual-number' : 'secondary-numbers';
    return translate(label);
}

showOtherNumbers(secondaryNumbers) {
    if (!Array.isArray(secondaryNumbers)) {
        secondaryNumbers = [secondaryNumbers]
    }
    let filteredNumbers = filter(secondaryNumbers, (el) => {
        return el != null;
    });
    return join(map(filteredNumbers, (element) => {
        return PhoneNumberFormat(element)
    }), " - ")
}

  componentDidMount() {
    const {
      setProducts,
      setMobileProducts,
      setMobileProductsForSearch,
      setFixeProducts,
      setInternetProducts,
      setTvProducts,
      setBundlesProducts,
    } = this.props;
    products.getProducts()
    .then((res) => {
      if (res) {
        if (res) {

          let mobileProducts= []
          let fixeProducts = []
          let internetProducts = []
          let tvProducts = []
          let bundlesProducts = []
          setProducts(res.body.data.userProducts);
          forEach(res.body.data.userProducts,(product) => {
            reverse(product.Options)
            if (product.Data.category === 'MOBILE') {
              mobileProducts.push(product)
            } else if (product.Data.category === 'FIXE'){
              fixeProducts.push(product)
            } else if (product.Data.category === 'INTERNET'){
              internetProducts.push(product)
            } else if (product.Data.category === 'TV'){
              tvProducts.push(product)
            } else if (product.Data.category === 'BUNDLES'){
              bundlesProducts.push(product)
            }
          })
          setMobileProducts(mobileProducts);
          setMobileProductsForSearch(mobileProducts);
          setFixeProducts(fixeProducts)
          setInternetProducts(internetProducts);
          setTvProducts(tvProducts);
          setBundlesProducts(bundlesProducts);
          this.props.loadServices();

        }
      }
    });
  }

  render() {
    const { translate, fixeProducts, isLoaded } = this.props;
    let activeFixeItems = [];
    forEach(fixeProducts,(product) => {
    if (product.Data.isActive ) {
      activeFixeItems.push(
        <MobileLineItem
        Data={product.Data}
        bundleName={product.Data.bundleName}
        isInBundle={product.Data.isInBundle}
        isFrozen={product.Data.isFrozen}
        hasFutureFreeze={product.Data.hasFutureFreeze}
        futureFreezeStartingDate={product.Data.futureFreezeStartingDate}
        currentFreezeEndDate={product.Data.currentFreezeEndDate}
        forwardData={product.Data.forwardData}
        isActive={product.Data.isActive}
        userProductId={product.Data.userProductId}
        offer={product.Data.offer}
        title={PhoneNumberFormat(product.Data.phoneNumber)}
        subscription1={translate('current-offer')}
        subtitle1={product.Data.offer}
        subscription2={this.virtualNumberNaming(product.Data.hasMissedCalls)}
        subtitle2={this.showOtherNumbers(product.Data.virtualPhoneNumber || product.Data.secondaryPhoneNumbers)}
        createdDate={product.Data.createdDate}
        simNumber={product.Data.simNumber}
        provider={product.Data.provider}
        options={product.Options}
        key={product.Data.userProductId}
        virtualPhoneNumber={this.showOtherNumbers(product.Data.virtualPhoneNumber)}
        hasFutureMispari={product.Data.hasFutureMispari}
        hasMispariActive={product.Data.hasMispariActive}
        isPendingActivation={product.Data.isPendingActivation}
        hasPendingUpgrade={product.Data.hasPendingUpgrade}
        pendingUpgradeInformations={''}
        hasOngoingTransfer={product.Data.hasOngoingTransfer}
        activationLink={product.Data.activationLink}
        pendingMigrationInformation={product.Data.pendingMigrationInformation}
        canActivateMispari={product.Data.canActivateMispari}
        hasApnFilter={product.Data.hasApnFilter}
        showOptions={product.Data.showOptions}
        cantBeDisplayInInactiveLines={product.Data.cantBeDisplayInInactiveLines}
        balance={product.Data.balance}
        isEsim={product.Data.isEsim}
        statusEsim={product.Data.statusEsim}
        lastIccidImei={product.Data.lastIccidImei}
    /> )
    } 
  })  
    
  return (
    <div className="service">
        <h1 className="title">{translate('land-line')}</h1>
        <h3 className="service-section-title">
          <span>{translate('activeMobileItems')}</span>
          <i className="material-icons ng-binding rotate-icon" data-toggle="collapse" data-target="#active" aria-expanded="false" >
            keyboard_arrow_down
          </i>
        </h3>
        <div id="active" className="collapse show">
        { isLoaded ? activeFixeItems[0] ? activeFixeItems : NoService(translate) : Loading() }
        </div>
      </div> 
  );
  }
}

const viewMapStateToProps = (state) => {
  return {
    products: state.Products.products,
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    fixeProducts: state.Products.fixeProducts,
    isLoaded: state.User.isLoaded,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setProducts: (products) => {
      dispatch(
        {
          type: 'SET_PRODUCTS',
          products: products,
        },
      );
    },
    setMobileProducts: (products) => {
      dispatch(
        {
          type: 'SET_MOBILE_PRODUCTS',
          products: products,
        },
      );
    },
    setMobileProductsForSearch: (products) => {
      dispatch(
        {
          type: 'SET_MOBILE_PRODUCTS_FOR_SEARCH',
          products: products,
        },
      );
    },
    setFixeProducts: (products) => {
      dispatch(
        {
          type: 'SET_FIXE_PRODUCTS',
          products: products,
        },
      );
    },
    setInternetProducts: (products) => {
      dispatch(
        {
          type: 'SET_INTERNET_PRODUCTS',
          products: products,
        },
      );
    },
    setBundlesProducts: (products) => {
      dispatch(
        {
          type: 'SET_BUNDLES_PRODUCTS',
          products: products,
        },
      );
    },
    setTvProducts: (products) => {
      dispatch(
        {
          type: 'SET_TV_PRODUCTS',
          products: products,
        },
      );
    },
    loadServices: () => {
      dispatch({
        type: 'LOAD_SERVICES_INFO',
        isLoaded: true,
      });

    },
  }
}

FixedLine = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(FixedLine);
export default FixedLine;



// WEBPACK FOOTER //
// ./src/components/MyServices/FixedLine.js